import 'lazysizes'
import '../styles/packages.scss'
import './tabs'

import { addDestinationFilterForEvents, sendFbTrack, hasAcceptedMarketing } from './utils/track'

// New Stimulus App
import { Application } from '@hotwired/stimulus'
import PostcodeFormController from './controllers/postcode_form_controller'
import DealTabsButtonController from './controllers/deal_tabs_button_controller'
import ProvidersController from './controllers/providers_controller'
import DealLinkController from './controllers/deal_link_controller'

const application = Application.start()
application.register('postcode-form', PostcodeFormController)
application.register('deal-tabs-button', DealTabsButtonController)
application.register('providers-listing', ProvidersController)
application.register('deal-link', DealLinkController)
// End Stimulus App

if (hasAcceptedMarketing()) {
  sendFbTrack()
} else if (typeof window !== 'undefined') {
  window.addEventListener('cookieConsentLoaded', () => {
    if (hasAcceptedMarketing()) {
      sendFbTrack()
    }
  })
}

addDestinationFilterForEvents([
  'Experiment Viewed',
  'Experiment Assigned',
  'Form Step Submitted',
  'Form Submitted',
  'Form Loaded',
  'Broadband Form Step Submitted',
  'Broadband Form Submitted',
  'Product List Loaded',
  'Product List Viewed',
  'Product Viewed',
  'Product Clicked',
  'Product Clickout',
  'Promotion Viewed',
  'Promotion Clicked',
  'Element Clicked',
  'Form Errored'
])

if (typeof window.nerdalytics !== 'undefined') {
  window.nerdalytics.page()
}
